import { FormControl, FormHelperText, TextareaAutosize, TextareaAutosizeProps } from '@material-ui/core';
import React from 'react';
import styles from './SGSTextarea.module.scss';
import classnames from 'classnames';

export type SGSTextareaProps = TextareaAutosizeProps & {
    label?: string;
    error?: boolean;
    helperText?: string;
};

const SGSTextarea: React.FC<SGSTextareaProps> = ({ error, id, name, label, helperText, className, ...props }) => {
    return (
        <FormControl error={error}>
            {label && (
                <label htmlFor={id || name} className={classnames(styles.label, error && styles.label__error)}>
                    {label}
                </label>
            )}
            <TextareaAutosize
                {...props}
                id={id || name}
                className={classnames(className, styles.textarea, error && styles.textarea__error)}
            />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default SGSTextarea;
